import { React, useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import LeaseApiService from '../../services/apiService';

const PropertyDetails = ({
  tableLoading,
  transectionData,
  setSubCommunity,
  setTransectionData,
  propertyType,
  setCityList,
  ownerShip,
  countriesList,
  projectStatus,
  community,
  cityList,
  subCommunity,
  districtList,
  propertyCategory,
}) => {
  const apiService = new LeaseApiService();

  const handleDateChange = async (input) => {
    const name = input?.target?.name || input.name;
    const value = input?.target?.value || input.value;
    setTransectionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleInputChange = (input) => {
    const name = input?.target?.name || input.name;
    const value = input?.target?.value || input.value;

    setTransectionData((prev) => {
      const updatedData = { ...prev, [name]: value };
      return updatedData;
    });
  };
  const handleDropDownChange = async ({ name, value }) => {
    if (name === 'district') {
      const str = value == null ? '' : typeof value === 'string' ? value.trim() : String(value?.label ?? value?.value?.text ?? '').trim();
      setTransectionData((prev) => ({ ...prev, district: str }));
      return;
    }
    if (name === 'country') {
      if (!value?.label) {
        setCityList([]);
        setTransectionData((prev) => ({
          ...prev,
          country: null,
          city: null,
          community: null,
          subCommunity: null,
        }));
        return;
      }
      const params = new URLSearchParams();
      params.append('DropdownFor', 'CitiesByCountry');
      params.append('CascadValue', value?.label);
      const res = await apiService.getApiParamater('PROPERTY_CASCAD', `?${params.toString()}`);
      setCityList(res?.data?.items || []);
      setTransectionData((prev) => ({
        ...prev,
        country: value,
        city: null,
        community: null,
        subCommunity: null,
      }));
      return;
    }
    if (name === 'community') {
      const params = new URLSearchParams();
      params.append('DropdownFor', 'SubCommunitiesByCommunitino');
      params.append('CascadValue', value?.value?.value);
      const res = await apiService.getApiParamater('PROPERTY_CASCAD', `?${params.toString()}`);
      setSubCommunity(res?.data?.items || []);
      setTransectionData((prev) => ({
        ...prev,
        community: value,
        subCommunity: null,
      }));
      return;
    }
    setTransectionData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <div className="cost-center-section my-3">
      <div className={`border-box2 p-3`}>
        {tableLoading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(255,255,255,0.6)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 10,
            }}
          >
            <div className="spinner-border text-primary" role="status" />
          </div>
        )}
        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Property No
            </label>
            <input type="text" className="p-2 form-control w-75" disabled value={transectionData?.propertyNo} onChange={handleInputChange} name="propertyNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Country
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.country}
              onChange={(selectedOption) => handleDropDownChange({ name: 'country', value: selectedOption })}
              options={countriesList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom18" className="form-label">
              Community
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.community}
              onChange={(selectedOption) => handleDropDownChange({ name: 'community', value: selectedOption })}
              options={community?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {' '}
              Name
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.propertyName} onChange={handleInputChange} name="propertyName" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              City
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.city}
              onChange={(selectedOption) => handleDropDownChange({ name: 'city', value: selectedOption })}
              options={cityList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              Sub Community
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.subCommunity}
              onChange={(selectedOption) => handleDropDownChange({ name: 'subCommunity', value: selectedOption })}
              options={subCommunity?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              {' '}
              Name (AR)
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.nameAr} onChange={handleInputChange} name="nameAr" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              District
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={(() => {
                const raw = transectionData?.district;
                const d = typeof raw === 'string' ? raw.trim() : raw?.label != null ? String(raw.label).trim() : '';
                if (!d) return null;
                const row = districtList?.find((x) => x.text === d);
                return row ? { value: row, label: row.text } : { label: d, value: { text: d } };
              })()}
              onChange={(selectedOption) => handleDropDownChange({ name: 'district', value: selectedOption })}
              options={districtList?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              Category
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.category}
              onChange={(selectedOption) => handleDropDownChange({ name: 'category', value: selectedOption })}
              options={propertyCategory?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              OwnerShip
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.ownerShip}
              onChange={(selectedOption) => handleDropDownChange({ name: 'ownerShip', value: selectedOption })}
              options={ownerShip?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Address{' '}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.address} onChange={handleInputChange} name="address" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Building No{' '}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.buildingNo} onChange={handleInputChange} name="buildingNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom22" className="form-label">
              Type
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.propertyType}
              onChange={(selectedOption) => handleDropDownChange({ name: 'propertyType', value: selectedOption })}
              options={propertyType?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Postal Code{' '}
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.postalCode} onChange={handleInputChange} name="postalCode" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Road No
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.roadNo} onChange={handleInputChange} name="roadNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Location
            </label>
            <input type="email" className="p-2 form-control w-75" value={transectionData?.location} onChange={handleInputChange} name="location" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Plot Size
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.plotSize} onChange={handleInputChange} name="plotSize" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Referred By
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.refferedBy} onChange={handleInputChange} name="refferedBy" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Project Status
            </label>
            <Select
              className="p-0 w-100"
              theme={(theme) => ({
                ...theme,
                borderRadius: 5,
                padding: 9,
              })}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                  color: state.isFocused ? '#000 ' : '#000',
                  ':hover': {
                    backgroundColor: '#F5F5F5',
                    color: '#000 ',
                  },
                }),
              }}
              value={transectionData?.projectStatus}
              onChange={(selectedOption) => handleDropDownChange({ name: 'projectStatus', value: selectedOption })}
              options={projectStatus?.map((country) => ({ value: country, label: country?.text }))}
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Referred On
            </label>
            <DatePicker
              todayButton="Today"
              selected={transectionData?.agreementDate}
              onChange={(date) => handleDateChange({ name: 'agreementDate', value: date })}
              dateFormat="dd-MMM-yyyy"
              className="p-2 form-control w-100"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Municipality No
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.municipalityNo} onChange={handleInputChange} name="municipalityNo" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Facilities
            </label>
            <textarea type="text" className="p-2 form-control w-75" value={transectionData?.facilities} onChange={handleInputChange} name="facilities" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Furniture Description
            </label>
            <textarea
              type="text"
              className="p-2 form-control w-75"
              value={transectionData?.furnitureDescription}
              onChange={handleInputChange}
              name="furnitureDescription"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Remarks (Internal)
            </label>
            <textarea
              type="text"
              className="p-2 form-control w-75"
              value={transectionData?.internalRemarks}
              onChange={handleInputChange}
              name="internalRemarks"
            />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Prefix For Receipt
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.prefixReceipt} onChange={handleInputChange} name="prefixReceipt" />
          </div>
          <div className="d-flex">
            <label htmlFor="validationCustom01" className="form-label pt-1 start">
              Block No
            </label>
            <input type="text" className="p-2 form-control w-75" value={transectionData?.blockNo} onChange={handleInputChange} name="blockNo" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default PropertyDetails;
